import script from "./receivablesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./receivablesPage.vue?vue&type=script&setup=true&lang=js"

import "./receivablesPage.vue?vue&type=style&index=0&id=5bb6bba6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb6bba6"]])

export default __exports__